import React from 'react';
import { Link, useParams } from 'react-router-dom';
import ViewIcon from '../../../../../Components/Icons/ViewIcon';
import NuAmount from '../../../../../Components/Utils/NuAmount';
import { TextSM } from '../../../../../Components/Text/NormalText';
import NuDate from '../../../../../Components/Utils/NuDate';

function ProductCompCard({ item }) {
    const { officeId , projectID} = useParams();

    // Extract min price from quotes
    const prices = item?.quotes?.map((sup) => sup.price) || [];
    const minPrice = Math.min(...prices);

    return (
        <div className="w-full border bg-white rounded-lg shadow-xl mt-1.5 mb-2">
            {/* Header */}
            <div className="flex justify-between bg-[#ECEBF3] rounded-t-lg items-center px-4 py-2">
                <p className="w-8 h-5 bg-slate-300 flex justify-center font-medium text-mainColor-500 items-center text-[12px] rounded-lg">
                    {item?.productId || "#"}
                </p>
                <div className="flex items-center gap-3">
                    <Link to={`/project/procurement/product-comparision/${officeId}/${projectID}/view/${item?.productId}`}>
                        <ViewIcon color="#048178" />
                    </Link>
                </div>
            </div>

            {/* Product Name */}
            <div className="px-2 pb-2">
                <div className="px-2 w-full h-8 mt-2 truncate overflow-hidden">
                    <Link
                        className="hover:text-blue-600 text-mainColor-400 font-semibold text-[12px] lg:text-[12px] xl:text-[12px] w-full flex justify-between items-center"
                        to={`/project/procurement/product-comparision/${officeId}/${projectID}/view/${item?.productId}`}
                    >
                        {item?.productName || "-"}
                    </Link>
                </div>

                {/* Quote List */}
                <div
                    className="w-full flex flex-col gap-2 mb-2 rounded-md p-2"
                    style={{ border: "1px solid #C0C0C0" }}
                >
                    {item?.quotes?.length > 0 ? (
                        item?.quotes?.slice(0, 3).map((sup, index) => (
                            <div key={index} className="flex justify-between items-center bg-gray-100 p-2 rounded-md">
                                {/* Price */}
                                <div>
                                    <p className={`text-[14px] ${sup?.price === minPrice && sup?.price !== 0 ? "text-green-600" : ""}`}>
                                        <NuAmount currency={sup?.currency} value={sup?.price || 0} />
                                        {sup?.isRecent && <span className="text-red-600">*</span>}
                                    </p>
                                    <p className="text-xs text-gray-500">
                                        {sup?.date && NuDate({ value: sup?.date, format: "DD-MMM-YY" })}
                                    </p>
                                </div>

                                {/* Vendor Name */}
                                <div>
                                    <TextSM content={"Supplier: "} />
                                    <p className="text-xs">{sup?.vendorName || "-"}</p>
                                </div>

                                {/* Count with Link */}
                                <div className="flex justify-center items-center">
                                    {sup?.count > 1 && (
                                        <Link to={`/project/procurement/product-comparision/priceView/${officeId}/${projectID}/${item?.productId}/${sup?.vendorId}`}>
                                            <div className="w-5 h-5 flex items-center justify-center rounded-full bg-baseColor-primary cursor-pointer text-white text-xs">
                                                {sup?.count}
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center text-gray-500 text-xs">No quotes available</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ProductCompCard;
